import { buildRefundTx } from './buildRefundTx.js';
export async function refund(signer, params) {
    const call = buildRefundTx(params);
    try {
        const { transaction_hash } = await signer.account.execute([call]);
        await signer.account.waitForTransaction(transaction_hash);
        return transaction_hash;
    }
    catch (error) {
        console.error('Error in refund:', error);
        throw error;
    }
}
